import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import Select from "react-select";
import BuildingService from "services/SalesDeveloper/BuildingService";
import PropertyService from "services/SalesDeveloper/PropertyService";
 
function BuildingModal({ modal, toggle, compound_id, building_id, ids ,setShouldGetData}) {
    const [loading, setLoading] = useState(true)
    const [buildingOpttions, setBuildingOpttions] = useState([])
    const [formData, setFormData] = useState({
        selectedBuilding: null
    })
    const buildingService = new BuildingService()
    const propertyService = new PropertyService()

    useEffect(()=>{
        buildingService.getDropDown(compound_id).then(res=>{
            let buildings =[]
            res.data?.map(item=>{
                buildings?.push({
                    label: item?.name?.en,
                    value: item.id
                })
            })
            setBuildingOpttions([...buildings?.filter(build => build?.value !== building_id)])
        })
    },[])

    const handleValidSubmit = () => {
        setLoading(true)
        let data ={
            unit_ids: ids,
            building_id: formData.selectedBuilding.value
        }
        propertyService.addToBuilding(data).then(res=>{
            if(res.status == SuccessOk){
                setLoading(false)
                toast.success("Properties added to Building Successfully")
                toggle()
                setShouldGetData(true)
                
                return
            }
        })
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalHeader toggle={toggle}>
                    Add Properties to Building
                 </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <label>Select Building</label>
                            <Select
                                placeholder='Select'
                                options={buildingOpttions}
                                onChange={data => {
                                    setFormData({ ...formData, selectedBuilding: data })
                                    setLoading(false)
                                }}
                                value={formData?.selectedBuilding}
                            />
                        </Col>
                    </Row>

                </ModalBody>

                <Row >
                        {/* <Col md={6} className='w-100'>
                            <button
                            onClick={toggle}
                            type='button'
                            className='btn btn-secondary w-100'>

                            Cancel
                            </button>
                        </Col> */}
                        <Col md={6}></Col>
                        <Col md={6} className='mt-3'>
                            <button
                            type='submit'
                            disabled={loading ? true : false}
                            className='btn btn-success w-100'>
                            Submit
                            </button>
                        </Col>
                    </Row>
            </AvForm>
        </Modal>

    )
}

export default BuildingModal
